import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import _get from 'lodash.get'
import { replaceWSTabLB } from '@nixi1/nx-channel-utils'

import { closeOutbound, toggleMinimizeOutbound, toggleMaximizeOutbound } from 'redux/outbound/actions'
import { marketing, meetAPI } from 'api'
import conversations from 'api/conversation/conversations'
import OutboundModalUI from './OutboundModalUI'
import { I18n } from 'react-redux-i18n'
import { toastMessage } from 'utils/messages'
import { marketingAct } from 'redux/actions'
import { getRecipients } from './utils'
import { verifyFileVirus } from 'utils/FileUtils'

function hasGetTemplate(config) {
  if(config.channel !== 'whatsapp') return true
  if(config.provider) return true

  return false
}

const OutboundModal = ({ outboundIndex, outbound }) => {
  const { brands, delegations, company, outboundModals, mktTemplates } = useSelector(state => ({
    brands: state.centers.brands,
    delegations: state.centers.delegations,
    company: state.companies,
    outboundModals: state.outbound.modals,
    mktTemplates: state.marketing?.templates
  }), shallowEqual)

  const [configOutbound, setConfigOutbound] = useState(outbound.currentData)
  const [headerInput, setHeaderInput] = useState({ type: '', value: '' })
  const [templates, setTemplates] = useState([])
  const [parsedTemplates, setParsedTemplates] = useState({})
  const [users, setUsers] = useState([])
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false)
  const [infoModal, setInfoModal] = useState({})
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false)
  const [send, setSend] = useState({ isSending: false, isSendingDraft: false, error: null })
  const [previewMessage, setPreviewMessage] = useState({})
  const [cleanEditor, setCleanEditor] = useState(0)
  const [isLoadingMeetLink, setIsLoadingMeetLink] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const outboundPortal = document.getElementById('outbound-portal')
  const inputButtons = {
    cc: {
      title: 'Cc',
      onClick: () => setConfigOutbound(prevState => ({
        ...prevState,
        visibleFields: [...prevState.visibleFields, 'cc']
      })),
    },
    cco: {
      title: 'Cco',
      onClick: () => setConfigOutbound(prevState => ({
        ...prevState,
        visibleFields: [...prevState.visibleFields, 'cco']
      }))
    }
  }
  const channels = [
    {
      name: 'WhatsApp',
      isEnable: true,
      provider: ''
    },
    {
      name: 'SMS',
      isEnable: true,
      provider: ''
    },
    {
      name: 'ChatMail',
      isEnable: true,
      provider: ''
    }
  ]
  const disclaimerMessage = configOutbound.channel === 'sms' && previewMessage.attachments?.length ? (
    <p dangerouslySetInnerHTML={{ __html: I18n.t('templates_copy_disclaimer_sms1') }}></p>
  ) : null

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!mktTemplates.variables?.length) {
        dispatch(marketingAct.getTemplateVariables())
      } else {
        setConfigOutbound(preVState => ({ ...preVState, templateVariables: mktTemplates.variables }))
      }
    }

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mktTemplates.variables])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (outboundModals.some(modal => modal.isOpen)) outboundPortal.style.display = 'flex'

      if (outboundModals.some(modal => modal.isMaximize)) {
        outboundPortal.style.top = '0'
        outboundPortal.style.right = '0'
        outboundPortal.style.bottom = '0'
        outboundPortal.style.left = '0'
        outboundPortal.style.backgroundColor = 'rgba(0, 0, 0, .5)'
      } else {
        outboundPortal.style.top = 'initial'
        outboundPortal.style.right = '150px'
        outboundPortal.style.bottom = '0'
        outboundPortal.style.left = 'initial'
        outboundPortal.style.backgroundColor = 'initial'
      }
    }

    return () => isSubscribed = false
  }, [outboundModals])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (hasGetTemplate(configOutbound)) {
        getTemplates({
          channel: configOutbound.channel,
          provider: configOutbound.provider
        })
      }

      if (configOutbound.channel) {
        conversations.getChannelsOPTOUT({ type: configOutbound.channel })
          .then(({ data }) => {
            if (!isSubscribed) return

            const deliveryChannels = []

            data.forEach(channelData => {
              deliveryChannels.push({
                value: channelData.id,
                label: `${channelData.value} (${channelData.name || channelData.delegationName})`,
                channel: channelData.channel,
                provider: channelData.provider,
                brand: {
                  id: channelData.brand,
                  name: channelData.brandName,
                },
                delegation: {
                  id: channelData.delegation,
                  name: channelData.delegationName,
                },
                assignToMe: channelData.assignToMe,
                isBlockedAssignToMe: channelData.assignToMe ? true : false
              })
            })

            setConfigOutbound(prevState => ({ ...prevState, deliveryChannelOptions: deliveryChannels }))
          })
      }

      setSend(prevState => ({ ...prevState, error: null }))
    }

    return () => isSubscribed = false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configOutbound.deliveryChannel, configOutbound.channel, configOutbound.provider])

  useEffect(() => {
    let isSubscribed = true

    if (templates.length && isSubscribed) {
      const parsedTemplates = {}

      templates.forEach(template => {
        parsedTemplates[template.channel] = {
          original: parsedTemplates[template.channel]?.original ? [
            ...parsedTemplates[template.channel].original,
            template
          ] : [
            template
          ],
          parsed: parsedTemplates[template.channel]?.parsed ? [
            ...parsedTemplates[template.channel].parsed,
            {
              label: template.name,
              value: template._id
            }
          ] : [
            {
              label: template.name,
              value: template._id
            }
          ]
        }
      })

      setParsedTemplates(parsedTemplates)
    }

    return () => isSubscribed = false
  }, [templates])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (headerInput.value.length > 2) {
        conversations.getUsersOPTOUT({
          channel: configOutbound.channel,
          text: headerInput.value
        })
          .then(({ data }) => {
            if (!isSubscribed) return
            setUsers({ [headerInput.type]: data })
          })
      } else {
        setUsers([])
      }
    }

    return () => isSubscribed = false
  }, [headerInput])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && brands?.length && delegations?.length && configOutbound.deliveryChannel.channel) {
      const deliveryChannelBrand = brands.filter(brand => brand.id === configOutbound.deliveryChannel.channel.brand.id)
      const deliveryChannelDelegation = delegations.filter(delegation => delegation.id === configOutbound.deliveryChannel.channel.delegation.id)

      if (deliveryChannelBrand.length && deliveryChannelDelegation.length) {
        setConfigOutbound(prevState => ({
          ...prevState,
          brand: deliveryChannelBrand,
          delegation: deliveryChannelDelegation
        }))
      }
    }

    return () => isSubscribed = false
  }, [configOutbound.deliveryChannel.channel])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) setPreviewMessage(configOutbound.message)

    return () => isSubscribed = false
  }, [configOutbound.message])

  const getTemplates = ({ channel, provider }) => {
    if (channel === 'whatsapp') return

    marketing.getAllTemplates({ type: 'CAMPAIGN', channel, provider, status: 'APPROVED' })
      .then(({ status, data }) => {
        if (status === 200) setTemplates(data.templates)
      })
  }

  const resetConfigOutbound = () => {
    setConfigOutbound(prevState => ({
      ...prevState,
      brand: [],
      delegation: [],
      deliveryChannel: {
        channel: null,
        assignToMe: false,
        isBlockedAssignToMe: false
      },
      deliveryChannelOptions: null,
      to: {
        chips: [],
        input: ''
      },
      cc: {
        chips: [],
        input: ''
      },
      cco: {
        chips: [],
        input: ''
      },
      template: null,
      subject: '',
      message: {},
      variables: []
    }))
    setCleanEditor(prevState => prevState + 1)
    setHeaderInput({ type: '', value: '' })
  }

  const toggleInfoModal = ({ type }) => {
    if (type) {
      if (type === 'templates') {
        if (configOutbound.channel === 'whatsapp') {
          setInfoModal({
            btnTxt: 'outbound_button_template',
            route: '/dashboard/conversations/templates?formTemplate=whatsapp',
            text: 'outbound_templates_info_whatsapp'
          })
        }
      }
      if (type === 'gmp') {
        if (configOutbound.channel === 'whatsapp' || configOutbound.channel === 'sms')  {
          setInfoModal({
            btnTxt: 'dashboard_create-campaign',
            route: '/dashboard/marketing/create/campaigns',
            text: 'outbound_contacts_info_whatsapp'
          })
        }
        if (configOutbound.channel === 'chatmail')  {
          setInfoModal({
            btnTxt: 'dashboard_create-campaign',
            route: '/dashboard/marketing/create/campaigns',
            text: 'outbound_contacts_info_chatmail'
          })
        }
      }
    } else {
      setInfoModal({})
    }

    setIsOpenInfoModal(!isOpenInfoModal)
  }

  const togglePreviewModal = () => setIsOpenPreviewModal(!isOpenPreviewModal)

  const handleContacts = ({ type, values }) => {
    if ((configOutbound.channel === 'whatsapp' || configOutbound.channel === 'sms') && values.chips.length <= 5) {
      return setConfigOutbound(prevState => ({
        ...prevState,
        [type]: {
          ...prevState[type],
          ...values
        }
      }))
    }

    if (configOutbound.channel === 'chatmail' && values.chips.length <= 10) {
      return setConfigOutbound(prevState => ({
        ...prevState,
        [type]: {
          ...prevState[type],
          ...values
        }
      }))
    }

    return toggleInfoModal({ type: 'gmp' })
  }

  const handleMinimize = () => dispatch(toggleMinimizeOutbound({ outboundIndex }))

  const handleMaximize = () => dispatch(toggleMaximizeOutbound({ outboundIndex }))

  const handleClose = () => {
    dispatch(closeOutbound({ outboundIndex }))
    if (outboundModals.length <= 1) outboundPortal.style.display = 'none'
  }

  const handleCloseChatmailField = ({ field }) => {
    const chatmailFieldIndex = configOutbound.visibleFields.findIndex(chatmailfield => chatmailfield === field)
    const newChatmailVisibleField = configOutbound.visibleFields
    newChatmailVisibleField.splice(chatmailFieldIndex, 1)

    setConfigOutbound(prevState => ({
      ...prevState,
      visibleFields: newChatmailVisibleField,
      [field]: {
        chips: [],
        input: ''
      }
    }))
  }

  const handleSend = ({ deliveryType, draftId }) => {
    if (!configOutbound.brand[0]) {
      return setSend(prevState => ({ ...prevState, error: 'brand' }))
    }
    if (!configOutbound.delegation[0]) {
      return setSend(prevState => ({ ...prevState, error: 'delegation' }))
    }

    const toValues = getRecipients(configOutbound.to.chips)
    if (toValues.length <= 0) {
      return setSend(prevState => ({ ...prevState, error: 'receiver' }))
    }

    if (!configOutbound.deliveryChannel?.channel?.value) {
      return setSend(prevState => ({ ...prevState, error: 'delivery-channel' }))
    }
    if (configOutbound.channel === 'chatmail' && !configOutbound.subject) {
      return setSend(prevState => ({ ...prevState, error: 'subject' }))
    }
    if (configOutbound.channel === 'whatsapp' && !configOutbound.template?.value) {
      return setSend(prevState => ({ ...prevState, error: 'template' }))
    }
    if (configOutbound.channel !== 'whatsapp' && !previewMessage.content) {
      return setSend(prevState => ({ ...prevState, error: 'message-content' }))
    }
    if (configOutbound.channel === 'whatsapp') {
      let error = false
      configOutbound.variables.forEach(it => {
        if (it.field === '' && !it?.value) error = true
      })
      if (error) {
        return setSend(prevState => ({ ...prevState, error: 'variables' }))
      }
    }

    if (deliveryType === 'message') {
      setSend(prevState => ({ ...prevState, isSending: true }))
    }
    if (deliveryType === 'draft') {
      setSend(prevState => ({ ...prevState, isSendingDraft: true }))
    }

    let data = {
      channelId: configOutbound.deliveryChannel.channel.value,
      brand: configOutbound.brand[0].value || configOutbound.brand[0].id,
      delegation: configOutbound.delegation[0].value || configOutbound.delegation[0].id,
      assignedToMe: configOutbound.deliveryChannel.assignToMe,
      to: toValues
    }
    if (configOutbound.channel === 'whatsapp') {
      data = {
        ...data,
        templateId: configOutbound.template.value,
        variables: configOutbound.variables?.map(it => ({
          ...it, value: replaceWSTabLB(it.value)
        })),
        message: {
          attachments: configOutbound?.message?.attachments || []
        }
      }
    }
    if (configOutbound.channel === 'sms') {
      data = {
        ...data,
        message: previewMessage
      }
    }
    if (configOutbound.channel === 'chatmail') {
      const ccValues = getRecipients(configOutbound.cc.chips)
      const ccoValues = getRecipients(configOutbound.cco.chips)

      data = {
        ...data,
        cc: ccValues,
        cco: ccoValues,
        subject: configOutbound.subject,
        message: previewMessage
      }
    }

    if (draftId) data.draftId = draftId
    if (deliveryType === 'message') {
      conversations.sendMessageOPTOUT(data)
        .then(result => {
          const { existVirus, attachmentsVirus } = verifyFileVirus({ data: result.data, dispatch, isOutbound: true })
          if(existVirus) {
            setPreviewMessage({
              ...previewMessage,
              attachments: attachmentsVirus
            })
            setConfigOutbound(state => ({
              ...state,
              message:{
                ...state.message,
                attachments: attachmentsVirus
              }
            }))
            throw result
          }
          if (result.status === 200) {
            resetConfigOutbound()
            toastMessage(I18n.t('outbound-modal-message-sent'))
            setTimeout(handleClose)
          }

          setSend(prevState => ({ ...prevState, isSending: false }))
        })
        .catch(() => {
          setSend(prevState => ({ ...prevState, isSending: false }))
          toastMessage(I18n.t('outbound-modal-message-sent-error'), 'error')
        })
    }
    if (deliveryType === 'draft') {
      if (draftId) {
        conversations.updateDraft({
          draftId,
          data: {
            ...data,
            type: 'outbound',
            channel: configOutbound.deliveryChannel.channel.name,
            provider: configOutbound.deliveryChannel.channel.provider
          }
        })
          .then(response => {
            if (response.status === 200) {
              resetConfigOutbound()
              toastMessage(I18n.t('draft_successful_update'))
              setTimeout(handleClose)
            }

            setSend(prevState => ({ ...prevState, isSendingDraft: false }))
          })
          .catch(() => {
            setSend(prevState => ({ ...prevState, isSendingDraft: false }))
            toastMessage(I18n.t('draft_error_update'), 'error')
          })
      } else {
        conversations.createDraft({
          ...data,
          type: 'outbound',
          channel: configOutbound.deliveryChannel.channel.name,
          provider: configOutbound.deliveryChannel.channel.provider
        })
          .then(response => {
            if (response.status === 200) {
              resetConfigOutbound()
              toastMessage(I18n.t('draft_successful_sent'))
              setTimeout(handleClose)
            }

            setSend(prevState => ({ ...prevState, isSendingDraft: false }))
          })
          .catch(() => {
            setSend(prevState => ({ ...prevState, isSendingDraft: false }))
            toastMessage(I18n.t('draft_error_sent'), 'error')
          })
      }
    }
  }

  const calcHeight = () => {
    if (configOutbound.channel === 'chatmail') {
      const newHeight = document.documentElement.clientHeight * 42 / 100
      return newHeight
    }
    else {
      const newHeight = document.documentElement.clientHeight * 47 / 100
      return newHeight
    }
  }

  const handleClickToCall = () => {
    setIsLoadingMeetLink(true)

    meetAPI.createLink({ outbound: true })
      .then(({ data }) => {
        setConfigOutbound(prevState => ({
          ...prevState,
          message: {
            ...prevState.message,
            content: data.message || `${I18n.t('dashboard_meet-link-created')}:`,
            buttons: [
              { label: I18n.t('dashboard_videocall'), content: data.url, type: "url" }
            ]
          }
        }))
        navigator.clipboard.writeText(data.url)
        toastMessage(I18n.t('dashboard_videocall-url-copied-clipboard'))
      })
      .catch(console.error)
      .finally(() => setIsLoadingMeetLink(false))
  }

  const replaceTemplateVariables = (text = '') => {
    const { company } = mktTemplates
    const user = {}

    user.name = configOutbound.to.chips[0]?.name || configOutbound.to.chips[0]?.value
    user.brandName = configOutbound.deliveryChannel.channel?.brand?.name
    user.delegationName = configOutbound.deliveryChannel.channel?.delegation?.name

    const data = { user, companyName: company.name }

    const message = configOutbound.variables.reduce((a, c) => a.replaceAll(c.name, _get(data, c.field, c.name)), text)

    return message
  }

  if (outbound.isOpen) {
    return ReactDOM.createPortal(
      <OutboundModalUI
        outboundIndex={outboundIndex}
        title={I18n.t('dashboard_new-conversation')}
        draftId={outbound.draftId}
        isMinimize={outbound.isMinimize}
        isMaximize={outbound.isMaximize}
        channels={channels}
        inputButtons={inputButtons}
        users={users}
        company={company}
        configOutbound={configOutbound}
        setConfigOutbound={setConfigOutbound}
        setHeaderInput={setHeaderInput}
        parsedTemplates={parsedTemplates}
        isOpenInfoModal={isOpenInfoModal}
        infoModal={infoModal}
        toggleInfoModal={toggleInfoModal}
        isOpenPreviewModal={isOpenPreviewModal}
        togglePreviewModal={togglePreviewModal}
        previewMessage={previewMessage}
        setPreviewMessage={setPreviewMessage}
        handleContacts={handleContacts}
        handleClose={handleClose}
        handleCloseChatmailField={handleCloseChatmailField}
        handleMinimize={handleMinimize}
        handleMaximize={handleMaximize}
        handleSend={handleSend}
        routeHistory={history}
        send={send}
        resetConfigOutbound={resetConfigOutbound}
        cleanEditor={cleanEditor}
        setCleanEditor={setCleanEditor}
        disclaimerMessage={disclaimerMessage}
        calcHeight={calcHeight}
        isLoadingMeetLink={isLoadingMeetLink}
        handleClickToCall={handleClickToCall}
        replaceTemplateVariables={replaceTemplateVariables}
      />,
      outboundPortal
    )
  }

  return null
}

export default OutboundModal
